module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "regiserpage",
    style: ({
      backgroundImage: 'url(' + _vm.url.url_1 + ')',
      backgroundSize: '100% 100%'
    })
  }, [_c('div', {
    staticClass: " display_column",
    staticStyle: {
      "height": "560px",
      "width": "500px",
      "padding-bottom": "10px",
      "color": "#0CDAD9",
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "registered_head display_row_js_ac dispaly_flex00",
    staticStyle: {
      "border": "none"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "16px"
    },
    attrs: {
      "src": require("./images/logincloseimg2.png")
    },
    on: {
      "click": function($event) {
        return _vm.click_gb()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "registered_end display_column_ac dispaly_flex11"
  }, [_c('div', {
    staticClass: "registered_end_2 display_row_ac dispaly_flex00",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('span', {
    staticClass: "registered_end_2_span"
  }, [_vm._v("所属单位：")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "所属单位",
      "filterable": "",
      "placement": "bottom"
    },
    model: {
      value: (_vm.name.ssdw),
      callback: function($$v) {
        _vm.$set(_vm.name, "ssdw", $$v)
      },
      expression: "name.ssdw"
    }
  }, _vm._l((_vm.dw), function(item) {
    return _c('Option', {
      key: item.ID,
      attrs: {
        "value": item.ID
      }
    }, [_vm._v(_vm._s(item.DWMC))])
  }), 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "13px",
      "right": "-36px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.showunit
    }
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("添加")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "registered_end_2 display_row_ac dispaly_flex00"
  }, [_c('span', {
    staticClass: "registered_end_2_span"
  }, [_vm._v("用户名：")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "用户名"
    },
    model: {
      value: (_vm.name.yhm),
      callback: function($$v) {
        _vm.$set(_vm.name, "yhm", $$v)
      },
      expression: "name.yhm"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "registered_end_2 display_row_ac dispaly_flex00"
  }, [_c('span', {
    staticClass: "registered_end_2_span"
  }, [_vm._v("密码：")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "password",
      "placeholder": "密码",
      "autocomplete": "new-password"
    },
    model: {
      value: (_vm.name.mm),
      callback: function($$v) {
        _vm.$set(_vm.name, "mm", $$v)
      },
      expression: "name.mm"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "registered_end_2 display_row_ac dispaly_flex00"
  }, [_c('span', {
    staticClass: "registered_end_2_span"
  }, [_vm._v("确认密码：")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "password",
      "placeholder": "确认密码"
    },
    model: {
      value: (_vm.name.zmm),
      callback: function($$v) {
        _vm.$set(_vm.name, "zmm", $$v)
      },
      expression: "name.zmm"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "registered_end_2 display_row_ac dispaly_flex00"
  }, [_c('span', {
    staticClass: "registered_end_2_span"
  }, [_vm._v("姓名：")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "姓名"
    },
    model: {
      value: (_vm.name.xm),
      callback: function($$v) {
        _vm.$set(_vm.name, "xm", $$v)
      },
      expression: "name.xm"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "registered_end_2 display_row_ac dispaly_flex00"
  }, [_c('span', {
    staticClass: "registered_end_2_span"
  }, [_vm._v("性别：")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "300px"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.name.xb),
      callback: function($$v) {
        _vm.$set(_vm.name, "xb", $$v)
      },
      expression: "name.xb"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "男"
    }
  }), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "女"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "registered_end_2 display_row_ac dispaly_flex00"
  }, [_c('span', {
    staticClass: "registered_end_2_span"
  }, [_vm._v("出生日期：")]), _vm._v(" "), _c('DatePicker', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "date",
      "placeholder": "出生日期",
      "clearable": false
    },
    model: {
      value: (_vm.name.rq),
      callback: function($$v) {
        _vm.$set(_vm.name, "rq", $$v)
      },
      expression: "name.rq"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "registered_end_2 display_row_ac dispaly_flex00"
  }, [_c('span', {
    staticClass: "registered_end_2_span"
  }, [_vm._v("电话：")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "电话"
    },
    model: {
      value: (_vm.name.dh),
      callback: function($$v) {
        _vm.$set(_vm.name, "dh", $$v)
      },
      expression: "name.dh"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "registered_end_2 display_row_ac dispaly_flex00"
  }, [_c('span', {
    staticClass: "registered_end_2_span"
  }, [_vm._v("邮箱：")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "邮箱"
    },
    model: {
      value: (_vm.name.yq),
      callback: function($$v) {
        _vm.$set(_vm.name, "yq", $$v)
      },
      expression: "name.yq"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "registered_save display_row_jc_ac dispaly_flex00",
    staticStyle: {
      "border": "none"
    }
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.checkadministrator()
      }
    }
  }, [_vm._v("注册")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-left": "20px",
      "font-size": "18px"
    }
  }, [_c('span', [_vm._v("注册用户")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-ea2f47d4"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/login/registered.vue
// module id = 1087
// module chunks = 1